export default class Skin {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    this.triggers = document.querySelectorAll('.js-skin-accordion-trigger');
    if (this.triggers.length === 0) return;

    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => this.toggleAccordion(e.currentTarget));
    });
  }

  toggleAccordion(trigger) {
    trigger.classList.toggle('is-State--Active');

    const content = this.getAccordionContent(trigger);
    if (!content) return;

    if (content.style.maxHeight) {
      // 閉じる
      content.style.maxHeight = null;
    } else {
      // 開く
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  getAccordionContent(trigger) {
    // trigger と兄弟要素にある .js-skin-accordion-contents を取得
    let sibling = trigger.nextElementSibling;
    while (sibling) {
      if (sibling.classList.contains('js-skin-accordion-contents')) {
        return sibling;
      }
      sibling = sibling.nextElementSibling;
    }
    return null;
  }
}
